import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "imagePreview",
    "genericPreview",
    "filename",
    "filesize",
    "dropZone",
    "input"
  ]

  static values = {
    existingFile: Boolean,
    existingImage: Boolean
  }

  connect() {
    if (this.existingFileValue) {
      this.showPreview(this.existingImageValue)
      this.showMetadata()
    } else {
      this.hidePreview()
      this.hideMetadata()
    }
  }

  handleFileChange() {
    const file = this.inputTarget.files[0]

    console.log(file)
    this.hidePreview()
    this.hideMetadata()
    this.showPreview(file.type.startsWith("image/"))
    this.showMetadata()
  }

  handleZoneClick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  handleDrop(event) {
    event.preventDefault()

    if (event.dataTransfer.files.length) {
      const file = event.dataTransfer.files[0]
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files

      this.handleFileChange()
    }
  }

  showPreview(isImage) {
    this.genericPreviewTarget.classList.toggle('hidden', isImage)
    this.imagePreviewTarget.classList.toggle('hidden', !isImage)

    const file = this.inputTarget.files[0]
    if (isImage && file instanceof File) {
      console.log("change")
      const objectURL = URL.createObjectURL(file);
      this.imagePreviewTarget.src = objectURL;
      this.imagePreviewTarget.onload = () => URL.revokeObjectURL(objectURL);
    }
  }

  hidePreview() {
    this.imagePreviewTarget.classList.add('hidden')
    this.genericPreviewTarget.classList.add('hidden')
  }

  showMetadata() {
    this.filenameTarget.classList.remove('hidden')
    this.filesizeTarget.classList.remove('hidden')

    const file = this.inputTarget.files[0]
    if (file instanceof File) {
      this.filenameTarget.innerText = this.inputTarget.files[0].name
      this.filesizeTarget.innerText = this.formatFileSize(this.inputTarget.files[0].size)
    }
  }

  hideMetadata() {
    this.filenameTarget.classList.add('hidden')
    this.filesizeTarget.classList.add('hidden')

    this.filenameTarget.innerText = ""
    this.filesizeTarget.innerText = ""
  }

  formatFileSize(bytes) {
    if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + " KB";
    } else {
      return (bytes / (1024 * 1024)).toFixed(2) + " MB";
    }
  }
}
